<template>
  <Loading class="center" v-if="loading" type="spinner" color="#2faeff" vertical
    >加载中...</Loading
  >
  <div
    v-else
    class="wrap"
  >
    <!-- 自定义的背景 -->
    <div class="content-wrap animate__animated  animate__slideInDown">
      <div class="content">
        <div class="timer-wrap">
          <Progress
            v-if="percentage"
            class="progress"
            :percentage="percentage"
            stroke-width="12"
            color="#AA6E29"
            :show-pivot="false"
            :track-color="percentageTrackColor"
          />
          <img src="@/assets/img/sdws/timer.png" alt="">
          <span>{{ countdown }}</span>
        </div>
        <div class="schedule">
          <img src="@/assets/img/sdws/schedule-icon.png" alt="">
          {{ schedule }}
          <img src="@/assets/img/sdws/schedule-icon.png" alt="">
        </div>
        <Choice
          :key="quesData?.questionKey"
          @submit="handleSelected"
          :data="quesData"
        />
      </div>
    </div>
    <img v-if="showShareTips" class="share-tips animate__animated animate__fadeInUp" src="@/assets/img/sdws/share-tips.png" alt="">
  </div>
  <div class="mask"></div>
  <!-- 成功/失败提示弹窗 -->
  <Overlay :show="showSuccess">
    <div class="result-tips">
      <img class="success-logo" src="@/assets/img/sdws/success-tip-icon.png" alt="">
      <p class="success-tips">恭喜您，答对了！</p>
      <img class="success-bottom" src="@/assets/img/sdws/success-tip-bottom.png" alt="">
    </div>
  </Overlay>
  <Overlay :show="showFail">
    <div
      class="result-tips fail-tips animate__animated animate__headShake"
      :class="{ 'short-fail' : !shareFlag }"
    >
      <p class="fail-text">回答错误，闯关结束！</p>
      <template v-if="shareFlag && recoverFlag">
        <button class="fail-btn" @click="handleClickShareButton">
          分享复活继续答题
        </button>
        <div @click="handleJump2Home" class="text">算了吧</div>
      </template>
      <button v-else class="fail-btn" @click="handleJump2Home">
        确认
      </button>
    </div>
  </Overlay>
</template>

<script>
import { Overlay, Dialog, Progress, Loading } from 'vant'
import { ref, computed, watch, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Choice from './components/choice'
import { submit } from '@/api/competition'
import { getQueryString } from '@/utils/tools'
import qs from 'qs'
import { useCommonQuesListEffect } from '@/effects/quesListEffect'
import { getRecoverInfo, recover } from '@/api/sdws'

export default {
  components: {
    Overlay,
    Choice,
    Loading,
    Progress
  },
  setup() {
    useShareEffect()
    const showFail = ref(false)
    const showSuccess = ref(false)

    const { percentage, percentageTrackColor, initPercentage, countdown, countInterval, startTime } = usePercentageEffect()

    // 初始化数据
    const { quesData, quesList, loading, currentIndex } = useQuesEffect(percentage, percentageTrackColor)

    const {
      handleSelected,
      schedule,
      answerGroupKey
    } = useSubmitEffect(
      quesData,
      quesList,
      percentage,
      percentageTrackColor,
      currentIndex,
      showSuccess,
      showFail,
      countdown,
      countInterval,
      startTime
    )

    const { recoverFlag, handleRecover } = useRecoverInfoEffect()

    // 分享相关
    const { showShareTips, shareFlag, handleClickShareButton } = useShareTipsEffect(showFail, initPercentage, quesData, countdown, handleRecover)

    // 失败结束
    const router = useRouter()
    const route = useRoute()
    const handleJump2Home = () => {
      router.replace({
        path: '/custom/sdws/result',
        query: {
          ...route.query,
          resultType: 1,
          answerGroupKey: answerGroupKey.value,
          isSuccess: 0
        }
      })
    }

    return {
      loading,
      showShareTips,
      quesData,
      percentage,
      percentageTrackColor,
      countdown,
      handleSelected,
      showSuccess,
      showFail,
      handleJump2Home,
      shareFlag,
      schedule,
      recoverFlag,
      handleRecover,
      handleClickShareButton
    }
  }
}

// 没有token跳到首页去
const useShareEffect = () => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const token = store.getters.getToken

  if (window.wx) {
    window.wx.hideAllNonBaseMenuItem()
  }

  // 没有token返回到首页去
  if (!token) {
    router.replace({
      path: '/custom/sdws/home',
      query: route.query
    })
  }
}

// 处理提交相关逻辑
const useSubmitEffect = (
  quesData,
  quesList,
  percentage,
  percentageTrackColor,
  currentIndex,
  showSuccess,
  showFail,
  countdown,
  countInterval,
  startTime
) => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const answerGroupKey = ref('')

  // 进度
  const schedule = computed(() => {
    return `${currentIndex.value + 1}/${quesList.value.length}`
  })
  const questionActiveKey = getQueryString('questionActiveKey')
  const isPreview = getQueryString('isPreview')
  const activeId = getQueryString('activeId')
  const unitId = getQueryString('unitId')

  // 点击提交
  let submitFlag = false

  // 监听倒计时
  watch(countdown, n => {
    // 倒计时结束
    if (n === 0) {
      // 倒计时结束 自动提交一个假的答案，后台不支持传空
      handleSelected([
        {
          questionKey: quesData.value.questionKey,
          answers: [
            {
              questionKey: quesData.value.questionKey,
              optionKey: 'no_answer'
            }
          ]
        }
      ])
    }
  })

  const handleSelected = async answers => {
    if (submitFlag) {
      return
    }
    if (showSuccess.value || showFail.value) {
      return
    }
    submitFlag = true
    const data = {
      questionActiveKey: questionActiveKey,
      answerJson: JSON.stringify(answers),
      longTime: new Date().getTime() - startTime.value,
      token: store.getters.getToken,
      isComplete: currentIndex.value + 1 === quesList.value.length ? 1 : 0,
      isStart: currentIndex.value + 1 === 1 ? 1 : 0,
      unitId: unitId,
      orgId: store.getters.getOrgId,
      isPreview,
      activeId: activeId
    }
    const res = await submit(qs.stringify(data))
    if (res.ok) {
      // 答对
      if (res.data) {
        showSuccess.value = true
        answerGroupKey.value = res.dataMap.answerGroupKey
        setTimeout(() => {
          currentIndex.value++
          // 闯关结束
          if (currentIndex.value === quesList.value.length) {
            router.replace({
              path: '/custom/sdws/result',
              query: {
                ...route.query,
                answerGroupKey: res.dataMap.answerGroupKey,
                resultType: 1,
                isSuccess: 1
              }
            })
            // router.replace(
            //   `/competition/result?questionActiveKey=${route.query.questionActiveKey}&activeId=${activeId}&unitId=${unitId}&resultType=1&answerGroupKey=${res.dataMap.answerGroupKey}&isSuccess=1`
            // )
            return
          }
          quesData.value = quesList.value[currentIndex.value]
          showSuccess.value = false
          // 初始化倒计时
          percentage.value = 100
          percentageTrackColor.value = '#AA6E29'
          countdown.value = store.getters.getQuesSetting.timeLimit
            ? store.getters.getQuesSetting.timeLimit
            : 30
          startTime.value = new Date().getTime()
        }, 400)
      } else {
        // 判断提交类型，是答错继续答题 还是答错终止
        if (store.getters.getQuesSetting.competitionType === 2) {
          showFail.value = true
          answerGroupKey.value = res.dataMap.answerGroupKey
          setTimeout(() => {
            currentIndex.value++
            // 闯关结束
            if (currentIndex.value === quesList.value.length) {
              router.replace({
                path: '/custom/sdws/result',
                query: {
                  ...route.query,
                  answerGroupKey: res.dataMap.answerGroupKey,
                  resultType: 1,
                  isSuccess: 1
                }
              })
              return
            }
            quesData.value = quesList.value[currentIndex.value]
            showFail.value = false
            // 初始化倒计时
            percentage.value = 100
            percentageTrackColor.value = '#AA6E29'
            countdown.value = store.getters.getQuesSetting.timeLimit
              ? store.getters.getQuesSetting.timeLimit
              : 30
          }, 400)
        } else {
          showFail.value = true
          answerGroupKey.value = res.dataMap.answerGroupKey
        }
      }
    } else {
      Dialog({ message: res.comment }).then(() => {
        router.push({
          path: '/',
          query: route.query
        })
        // router.push(
        //   `/?questionActiveKey=${questionActiveKey}&isPreview=${isPreview}&activeId=${activeId}&unitId=${unitId}`
        // )
      })
    }
    submitFlag = false
  }

  return {
    showSuccess,
    showFail,
    handleSelected,
    schedule,
    answerGroupKey,
    percentage,
    countdown
  }
}

// 初始化题目
const useQuesEffect = (percentage, percentageTrackColor) => {
  const quesList = ref([])
  const currentIndex = ref(0)
  const quesData = ref(null)

  const { getQuesData, loading } = useCommonQuesListEffect()
  getQuesData(quesList, quesData)

  return {
    quesList,
    currentIndex,
    quesData,
    percentage,
    percentageTrackColor,
    loading
  }
}

// 进度条
const usePercentageEffect = () => {
  const store = useStore()
  const percentage = ref(100)
  const percentageTrackColor = ref('#AA6E29')

  // 开始时间
  const startTime = ref(new Date().getTime())

  const timeLimit = store.getters.getQuesSetting.timeLimit
    ? store.getters.getQuesSetting.timeLimit
    : 30
  const countdown = ref(timeLimit)

  const countInterval = setInterval(() => {
    percentage.value = (countdown.value / timeLimit) * 100
    percentageTrackColor.value = 'none'
    if (countdown.value > 0) {
      countdown.value--
    }
  }, 1000)

  onBeforeUnmount(() => {
    clearInterval(countInterval)
  })

  const initPercentage = () => {
    percentage.value = 100
    percentageTrackColor.value = '#AA6E29'
    countdown.value = store.getters.getQuesSetting.timeLimit
      ? store.getters.getQuesSetting.timeLimit
      : 30
  }

  return {
    percentage,
    percentageTrackColor,
    countdown,
    initPercentage,
    countInterval,
    startTime
  }
}

// 分享提示
const useShareTipsEffect = (showFail, initPercentage, quesData, countdown) => {
  const showShareTips = ref(false)
  const shareFlag = ref(true)
  const store = useStore()
  const route = useRoute()
  const handleRecover = async () => {
    const res = await recover({
      questionActiveKey: route.query.questionActiveKey,
      token: store.getters.getToken
    })

    console.log('res', res)
  }
  if (window.wx) {
    window.wx.onMenuShareAppMessage({
      title: store.getters.getShareInfo?.shareTitle || document.title,
      desc: store.getters.getShareInfo?.shareDesc,
      imgUrl: store.getters.getShareInfo?.shareIcon,
      link: `https://qlwhdh.iqilu.com/h5/#/custom/sdws/?questionActiveKey=${route.query.questionActiveKey}`,
      success: function () {
        if (window.wx) {
          window.wx.hideAllNonBaseMenuItem()
        }
        handleRecover()
        shareFlag.value = false
        // 清空选项
        quesData.value.optionVoList.map(item => { item.select = false })
        // countdown.value = store.getters.getQuesSetting.timeLimit
        //   ? store.getters.getQuesSetting.timeLimit
        //   : 30
        showFail.value = false
        showShareTips.value = false
        initPercentage()
      }
    })
    window.wx.onMenuShareTimeline({
      title: store.getters.getShareInfo?.shareTitle || document.title,
      desc: store.getters.getShareInfo?.shareDesc,
      imgUrl: store.getters.getShareInfo?.shareIcon,
      link: `https://qlwhdh.iqilu.com/h5/#/custom/sdws/?questionActiveKey=${route.query.questionActiveKey}`,
      success: function () {
        handleRecover()
        shareFlag.value = false
        // 清空选项
        quesData.value.optionVoList.map(item => { item.select = false })
        // countdown.value = store.getters.getQuesSetting.timeLimit
        //   ? store.getters.getQuesSetting.timeLimit
        //   : 30
        showFail.value = false
        showShareTips.value = false
        initPercentage()
      }
    })
  }

  // 点击分享按钮
  const handleClickShareButton = () => {
    if (window.wx) {
      window.wx.showAllNonBaseMenuItem()
    }
    showShareTips.value = true
  }

  return {
    showShareTips,
    shareFlag,
    handleClickShareButton
  }
}

// 获取复活次数
const useRecoverInfoEffect = () => {
  const recoverFlag = ref(true)
  const store = useStore()
  const route = useRoute()

  const fetchData = async () => {
    const res = await getRecoverInfo({
      questionActiveKey: route.query.questionActiveKey,
      token: store.getters.getToken
    })

    if (res.ok) {
      recoverFlag.value = res.data
    }
  }

  // 复活
  const handleRecover = async () => {
    const res = await recover({
      questionActiveKey: route.query.questionActiveKey,
      token: store.getters.getToken
    })

    console.log('res', res)
  }

  fetchData()

  return {
    recoverFlag,
    handleRecover
  }
}
</script>

<style lang="scss" scoped>
.center {
  height: 100vh;
  margin: 400px auto;
  text-align: center;
}
.wrap {
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  width: 750px;
  height: 100vh;
  min-height: 100vh;
  background: url('../../../assets/img/sdws/content-bg.png');
  background-size: 100% 100%;
}

.mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.4);
}

.content-wrap {
  margin: 0 auto;
  width: 700px;
  height: 1250px;
  max-height: 100vh;
  background: no-repeat top/100%
    url('../../../assets/img/sdws/content-wrap.png');
  z-index: 1;
  .content {
    position: relative;
    padding-top: 180px;
    margin: 0 auto;
    min-height: 823px;
    border-radius: 10px;

    .timer-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      .progress {
        border: 1px solid #71430E;
        width: 416px;
        border-radius: 30px;
      }
      img {
        margin-left: 22px;
        width: 40px;
        height: 40px;
      }
      span {
        margin-left: 10px;
        font-size: 32px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #8E5717;
      }
    }

    .schedule {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 54px;
      font-size: 36px;
      text-align: center;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: bold;
      color: #401913;

      img {
        width: 54px;
        height: 38px;

        &:first-child {
          margin-right: 24px;
        }

        &:last-child {
          margin-left: 24px;
          transform: rotate(180deg);
        }

      }
    }
  }
}
.share-tips {
  position: absolute;
  top: 0;
  right: 62px;
  width: 520px;
  height: 380px;
  z-index: 2;
}
.result-tips {
  margin: 0 auto;
  width: 568px;
  height: 306px;
  margin-top: 590px;
  background: no-repeat center/100% url('../../../assets/img/sdws/tips-bg.png') ;
  img.success-logo {
    display: block;
    position: relative;
    top: -20px;
    margin: 0 auto;
    width: 128px;
    height: 128px;
  }

  p.success-tips {
    margin-top: 10px;
    text-align: center;
    font-size: 48px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: bold;
    color: #401913;
  }

  img.success-bottom {
    display: block;
    margin: 0 auto;
    margin-top: 38px;
    width: 486px;
    height: 16px;
  }
}

.fail-tips {
  box-sizing: border-box;
  position: relative;
  padding-top: 50px;
  height: 350px;

  .fail-text {
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
    max-width: 484px;
    font-size: 32px;
    line-height: 48px;
    font-family: FZLTHK--GBK1-0, FZLTHK--GBK1;
    color: #401913;
  }

  .short {
    margin-top: 10px;
    max-width: 368px;
  }

  .fail-btn {
    display: block;
    margin: 0 auto;
    margin-top: 28px;
    width: 374px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #FFF5C6;
    background: no-repeat center/100% url('../../../assets/img/sdws/content-start-btn.png');
  }

  .text {
    margin-top: 20px;
    text-align: center;
    font-size: 32px;
    font-family: FZLTHK--GBK1-0, FZLTHK--GBK1;
    font-weight: normal;
    color: #61352E;
  }
}

.short-fail {
  height: 306px;

  .fail-text {
    margin-top: 38px;
  }
}

.fish-btn {
  display: block;
  margin: 0 auto;
  margin-top: 320px;
  width: 433px;
  height: 111px;
  background: linear-gradient(0deg, #ff9c2e, #ffde3a);
  box-shadow: 0px 1px 10px 0px rgba(254, 167, 74, 0.57);
  border-radius: 56px;
  border: none;
  font-size: 42px;
  color: #ffffff;
}
.normal {
  background: linear-gradient(265deg, #2b91ff, #1fbcff);
}
@media (max-height: 800px) {
  .wrap {
    .rule {
      .btn {
        margin-top: 60px;
      }
    }
  }
}
</style>
<style>
.van-circle__text {
  font-size: 22px !important;
  color: #fd7777 !important;
}
.company {
  position: relative;
  top: -40px;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  color: #26a3ff;
  opacity: 0.7;
}
</style>
